import * as React from "react";
import Avatar from "@mui/joy/Avatar";
import Box from "@mui/joy/Box";
import List from "@mui/joy/List";
import ListItem from "@mui/joy/ListItem";
import ListItemContent from "@mui/joy/ListItemContent";
import ListItemDecorator from "@mui/joy/ListItemDecorator";
import Typography from "@mui/joy/Typography";
import { YellowCircle } from "../Table";

export default function EllipsisList({ items, index }) {
  const { message, time, seen, img } = items;
  const [notificationSeen, setNotificationSeen] = React.useState(seen);
  const handleSeen = () => {
    setNotificationSeen(true);
  };
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
      }}
    >
      <List
        aria-labelledby="ellipsis-list-demo"
        sx={{ "--List-decorator-size": "56px" }}
      >
        <ListItem onClick={() => handleSeen(index)} sx={{ cursor: "pointer" }}>
          <ListItemDecorator sx={{ alignSelf: "flex-start", mb: 1 }}>
            <Avatar src={img} />
          </ListItemDecorator>
          <ListItemContent>
            <Typography sx={{ color: "white", fontSize: "16px" }} noWrap>
              {message}
            </Typography>
            <Typography sx={{ color: "white", fontSize: "10px" }}>
              {time}
            </Typography>
          </ListItemContent>
        </ListItem>
      </List>
      <Box sx={{ mr: 1 }}>
        {notificationSeen ? (
          "Seen"
        ) : (
          <YellowCircle handleSeen={handleSeen} index={index} />
        )}
      </Box>
    </Box>
  );
}
